import PropertyLink from './property-link';

export default PropertyLink;
